import { EditorState, ContentState } from 'draft-js'
import { stateToHTML } from 'draft-js-export-html'
import htmlToDraft from 'html-to-draftjs'
import * as R from 'ramda'

import decorator from './decorator'

export function convertHTMLToDraftEditor(html) {
  const content = _createContentStateFromHtml(html)

  return content.getBlockMap().size
    ? EditorState.createWithContent(content, decorator)
    : EditorState.createEmpty(decorator)
}

function _protectDoubleNewLines(html) {
  return R.replace(/<br>/g, '', html)
}

function _createContentStateFromHtml(html) {
  const blocksFromHtml = htmlToDraft(_protectDoubleNewLines(html))
  const { contentBlocks, entityMap } = blocksFromHtml
  return ContentState.createFromBlockArray(contentBlocks, entityMap)
}

export function draftEditorToHTMLCode(editorState) {
  return stateToHTML(editorState.getCurrentContent())
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/RichEditor/utils.js